import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Modal } from 'react-responsive-modal';
import './index.scss';

const ModalName = 'ModalTeam';

const Team = ({ name, toggleModal }) => {
	const closeModal = () => toggleModal(ModalName);
    const {selectedTeam} = useSelector(
        (state) => ({
            selectedTeam: state.main.selectedTeam,
        }),
        shallowEqual
    );
	return (
		<Modal
			open={name[ModalName]}
			classNames={{
				modal: `modal modal-team`,
				overlay: 'overlay',
				closeButton: 'close-button',
				closeIcon: 'close-icon',
				modalAnimationIn: 'slideInUp',
				modalAnimationOut: 'slideOutDown',
			}}
			animationDuration={250}
			center
			focusTrapped={false}
			onClose={closeModal}
			blockScroll={false}
		>
			<div className="modal-content">
                {
                    selectedTeam && <img alt="" src={process.env.REACT_APP_CDN_URL + 'team/' + selectedTeam.img + '.jpg'} />
                }
			</div>
		</Modal>
	);
};

export default Team;
